import { Box, Icon } from "@mui/material";
import { MouseEventHandler, ReactElement } from "react"
import { useContextState } from "../../../../hooks/theme";
import { icons } from "../../../../utils/icons";

const useStyles = () => {
    const { colors } = useContextState()
    return {
        boxBorder: {
            width: '100%',
            borderRadius: '4px',
            border: `1px solid ${colors.color13}`,
            padding: 1,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            rowGap: 2
        },
        arrow: {
            flex: 1,
            textAlign: 'end',
            fontSize: '20px',
            width: '20px',
            height: 'fit-content',
            '& .MuiSvgIcon-root': {
                fontSize: '1em',
                width: '1em',
                height: '1em',
            }
        },
        active: {
            cursor: 'pointer',
            '&:hover': {
                boxShadow: "1px 1px 2px #d7d7d7, -1px -1px 2px #e9e9e9",
                transition: 'all 0.5s ease'
            }
        }
    }
}
const ClickedBox = ({ children, active, rightChildren, body, click }: { body?: ReactElement; children: ReactElement; active?: boolean; click?: MouseEventHandler<HTMLDivElement>, rightChildren?: ReactElement }) => {
    const styles = useStyles()
    return (
        <Box sx={[styles.boxBorder, active ? styles.active : {}]} >
            {children}

            {(active && !!rightChildren) && !click && rightChildren}

            {(active && click && !rightChildren) && <Icon onClick={click} sx={styles.arrow}>{icons('arrow-right')}</Icon>}

            {!!body && body}
        </Box>
    )
}

export { ClickedBox }
